import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { useScrollToBottom } from 'react-scroll-to-bottom';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import Loader from 'sharedComponents/Loader';
import ChatUserPresenter from 'presenters/ChatUserPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import Message from './components/Message';

import useStyles from './useStyles';

const Messages = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { messages, isLoading, currentUser, participant, chatUid } = props;

  const scrollToBottom = useScrollToBottom();

  let firstMessageUid;
  if (messages.length > 0) {
    firstMessageUid = messages[0].uid;
  }

  useEffect(() => {
    scrollToBottom({ behavior: 'smooth' });
  }, [chatUid]);

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <Loader />
      </div>
    );
  }

  if (isEmpty(messages)) {
    return (
      <Box textAlign="center" mt={2} height="100%" px={2}>
        <Typography className={classes.messagesPlaceholder} variant="subtitle1">
          {t('components.Chat.messagesPlaceholder')}
        </Typography>
      </Box>
    );
  }

  return messages.map(message => {
    const { senderId } = message;
    const isCurrentUserMessage = senderId === currentUser.id;
    return (
      <Message
        key={message.uid}
        isFirstMessage={message.uid === firstMessageUid}
        chatUid={chatUid}
        author={isCurrentUserMessage ? currentUser : participant}
        message={message}
        isCurrentUserMessage={isCurrentUserMessage}
      />
    );
  });
};

Messages.propTypes = {
  participant: ChatUserPresenter.shape().isRequired,
  chatUid: PropTypes.string.isRequired,
  currentUser: ChatUserPresenter.shape().isRequired,
  messages: PropTypes.arrayOf(MessagePresenter.shape()).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default Messages;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/Messages.js